import { useState } from 'react';
import { ILineResource } from '../../entities/farms.entities';
import { Modal } from 'antd';
import { Button, CloseIcon, Subtitle } from '../shared';
import { translate } from '../../lib/lang.helper';
import { useDispatch, useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import SelectCropType from '../farmform/SelectCropType';
import { sendSingleRequest } from '../../apis';
import { showFeedback } from '../../store/ui/ui.actions';
import { loadFarmsData } from '../../store/farms/farms.actions';

interface Props {
  visible: boolean;
  lineData: ILineResource;
  onClose: () => void;
  loadLine?: () => void;
}

const LineCropTypeModal = ({ visible, lineData, onClose, loadLine }: Props) => {
  const dispatch = useDispatch<any>();
  const lang = useSelector(selectLang);

  const [type, setType] = useState(lineData.crop_type);
  const [disabled, setDisabled] = useState(false);

  const confirmChange = async () => {
    if (type === lineData.crop_type) {
      return;
    }
    setDisabled(true);
    const response = await sendSingleRequest(
      { crop_type: type },
      'PUT',
      `api/farm/line/lines/${lineData.id}`,
      true,
    );
    if (response.status) {
      await dispatch(loadFarmsData());
      if (loadLine) {
        await loadLine();
      }
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'success',
          message: translate(lang, 'Crop type changed successfully'),
        }),
      );
      onClose();
    } else {
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'error',
          message:
            response.data?.message ??
            translate(lang, 'Failed to change crop type'),
        }),
      );
      setDisabled(false);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      closable
      closeIcon={<CloseIcon />}
      footer={null}
    >
      <div className='wrap'>
        <div className='d-flex align-center mb-16'>
          <Subtitle color='black-1' align='left' size={1} fontWeight={600}>
            {translate(lang, 'Change Crop Type')}
          </Subtitle>
        </div>
        <div className='pt-16'>
          {lineData.growing_cycle ? (
            <div className='header-alert'>
              {translate(
                lang,
                'The line is growing now, crop type cannot be changed.',
              )}
            </div>
          ) : (
            <SelectCropType
              value={type}
              onChange={val => val && setType(val)}
            />
          )}
        </div>
      </div>
      <div className='mt-32 modal-button d-flex justify-end align-center'>
        <Button
          className='mr-32'
          width={'small'}
          size={2}
          type='fill'
          color='red'
          disabled={disabled}
          onClick={onClose}
        >
          {translate(lang, 'Close')}
        </Button>
        <Button
          width={'small'}
          size={2}
          type='fill'
          color='green'
          disabled={
            disabled || type === lineData.crop_type || !!lineData.growing_cycle
          }
          onClick={confirmChange}
        >
          {translate(lang, 'Confirm')}
        </Button>
      </div>
    </Modal>
  );
};

export default LineCropTypeModal;
